var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _c("div", { staticClass: "bg-lightblue px-2 py-2" }, [
      _c(
        "div",
        {
          staticClass: "input-unit order-property-input",
          class: { active: _vm.property.value, error: _vm.hasError },
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectionValue,
                  expression: "selectionValue",
                },
              ],
              staticClass: "custom-select p-3",
              attrs: {
                id: "order-property-input-select",
                "data-testing": "order-property-selection",
              },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectionValue = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function ($event) {
                    return _vm.onInputValueChanged($event.target.value)
                  },
                ],
              },
            },
            [
              _c("option", { domProps: { selected: true, value: null } }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.singleItemPleaseSelect")
                  )
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.property.selectionValues, function (value, id) {
                return _c(
                  "option",
                  {
                    key: id,
                    attrs: {
                      "data-testing": "order-property-selection-option",
                    },
                    domProps: { selected: _vm.property.id === id, value: id },
                  },
                  [_vm._v(_vm._s(value.name))]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "d-flex w-100",
              attrs: { for: "order-property-input-select" },
            },
            [
              _c("span", { staticClass: "text-truncate" }, [
                _vm._v(_vm._s(_vm.property.names.name)),
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticClass: "ml-1" },
                [
                  _vm.surcharge > 0
                    ? [
                        _vm._v(
                          "(+ " +
                            _vm._s(_vm._f("currency")(_vm.surcharge)) +
                            ")"
                        ),
                      ]
                    : _vm._e(),
                  _c("span", [_vm._v(" " + _vm._s(_vm.footnotes))]),
                ],
                2
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }